import RoleAssignmentHashTableTypes from "src/pages/hr/Types/RoleAssignmentHashTableTypes"
import roleAssignmentHelper from "./RoleAssignmentHelper"

const handleAddOrDropView = (bucketItem: RoleAssignmentHashTableTypes, operation?: "+" | "-" | "all" | "!all") => {
    let temp = bucketItem
    let tempAt1 = temp[1]

    if (operation) {

        if (!tempAt1.hasView && operation === "+") {
            tempAt1.dropView = false
            tempAt1.addView = true
        } else if (operation === "-") {
            tempAt1.dropView = true
            tempAt1.addView = false
        }
        else if (operation === "all") {
            tempAt1.dropView = false
            if (!tempAt1.hasView) {
                tempAt1.addView = true
            }
        }
        else if (operation === "!all") {
            tempAt1.dropView = false
            if (tempAt1.hasView) {
                tempAt1.dropView = true
            }
            tempAt1.addView = false
        }

    } else {

        if (tempAt1.hasView && !tempAt1.dropView) {
            tempAt1.dropView = true
        } else if (tempAt1.hasView && tempAt1.dropView) {
            tempAt1.dropView = false
        }

        if (!tempAt1.hasView && !tempAt1.addView) {
            tempAt1.addView = true
        } else if (!tempAt1.hasView && tempAt1.addView) {
            tempAt1.addView = false
        }
    }

    temp[1] = tempAt1

    roleAssignmentHelper.updateHashTableItem(temp)
    const storage = roleAssignmentHelper.getStorage()
    return storage
}

export default handleAddOrDropView